import React from 'react';

const miniWrapper = 'w-6 h-6';
const bigWrapper = 'w-[4.5rem] h-[4.5rem]';
const spinner =
  "relative h-full w-full [&::after]:content-[''] [&::after]:absolute [&::after]:w-full [&::after]:h-full [&::after]:top-0 [&::after]:left-0 [&::after]:rounded-full [&::after]:border-t-4 [&::after]:border-l-4 [&::after]:border-b-4 [&::after]:border-r-4 [&::after]:border-t-primary [&::after]:border-l-primary [&::after]:border-b-primary [&::after]:border-r-transparent [&::after]:border-solid [&::after]:animate-[spinner_1s_linear_infinite]";
const whiteSpinner = '[&::after]:border-t-white [&::after]:border-l-white [&::after]:border-b-white';

type Props = {
  isMini?: boolean;
  isWhite?: boolean;
};
export default function LoadingSpinner({ isMini = false, isWhite = false }: Props) {
  return (
    <div className={`${isMini ? miniWrapper : bigWrapper} `} data-testid="loading-spinner">
      <div className={`${spinner} ${isWhite ? whiteSpinner : ''}`} />
    </div>
  );
}
